import type { JSX } from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { featureFlagsFromBuild } from './config/feature-flags.js';
import { appRoutes } from './routes.js';

const router = createBrowserRouter(appRoutes(featureFlagsFromBuild()));

export function App(): JSX.Element {
  return <RouterProvider router={router} />;
}
